import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProfileSyncService } from '../../../services/profile-sync.service';
import { TransactionFailedRecord } from '../../../model/Transaction';
import { EventEmitterWithObservable } from '../../../../shared/EventEmitterWithValueReturned';
import { SnfLegacyMigrationService } from '../../../services/snf-legacy-migration.service';


@Component({
    selector: 're-snf-legacy-user-import-failed',
    templateUrl: './snf-legacy-user-import-failed.component.html',
    styleUrls: ['./snf-legacy-user-import-failed.component.scss'],
    standalone: false
})
export class SnfLegacyUserImportFailedComponent implements OnInit {
  ngOnInit(): void {
  }

  constructor(private sngLegacyService: SnfLegacyMigrationService, private route: ActivatedRoute) { }


  failedUsers: TransactionFailedRecord[];

  load($event: EventEmitterWithObservable) {
    $event.ReturnValue = this.sngLegacyService.getFailedUsers(+this.route.snapshot.params.processId);
  }

}
